import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const colors = [
    "rgba(255, 99, 132, 0.6)",
    "rgba(54, 162, 235, 0.6)",
    "rgba(255, 206, 86, 0.6)",
    "rgba(75, 192, 192, 0.6)",
    "rgba(153, 102, 255, 0.6)",
    "rgba(255, 159, 64, 0.6)"
];
const EventFeeBarChart = ({ barChartData }) => {

    const data = {
        labels: barChartData?.map(p=>p.criteria),
        datasets: [
            {
                label:'Total registered players',
                data: barChartData?.map(p => p.totalPlayer),
                backgroundColor: function(context) {
                    const chart = context.chart;
                    const { ctx, chartArea } = chart;
                    if (!chartArea) return;
                    const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                    gradient.addColorStop(0, '#c7e25f');
                    gradient.addColorStop(0.5, '#8fbd04');
                    gradient.addColorStop(1, '#5c7f00');
                    return gradient;
                }
            }
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: "top" },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: { stepSize: 500 },
            },
        },
    };

    return (
        <div style={{ width: "100%", height: "90%" }}>
            <Bar data={data} options={options} style={{ height: '100%' }} />
        </div>
    );
};

export default EventFeeBarChart;
